import { styled } from "styled-components";

export const SpinnerOverlay = styled.div`
  height: 60vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SpinnerContainer = styled.div`
 display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;

  background: conic-gradient(
    from 0deg,
    oklch(65% 0.25 20),
    oklch(70% 0.22 80),
    oklch(70% 0.22 160),
    oklch(65% 0.25 240),
    oklch(65% 0.25 320),
    oklch(65% 0.25 20)
  );

  -webkit-mask: radial-gradient(
    farthest-side,
    transparent calc(100% - 4px),
    #000 calc(100% - 3px)
  );

  mask: radial-gradient(
    farthest-side,
    transparent calc(100% - 4px),
    #000 calc(100% - 3px)
  );

  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
`;
